"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var GridWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: ", ";\n  flex-wrap: wrap;\n  margin-left: ", ";\n  margin-top: ", ";\n  width: ", ";\n  > div {\n    padding-left: ", ";\n    padding-top: ", ";\n    // flex: 1;\n  }\n  ", "\n"], ["\n  display: flex;\n  flex-grow: 1;\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: ", ";\n  flex-wrap: wrap;\n  margin-left: ", ";\n  margin-top: ", ";\n  width: ", ";\n  > div {\n    padding-left: ", ";\n    padding-top: ", ";\n    // flex: 1;\n  }\n  ", "\n"])), function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent;
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems;
}, function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return "-" + theme.spacing[spacing];
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return "-" + theme.spacing[spacing];
}, function (_a) {
    var width = _a.width, theme = _a.theme, spacing = _a.spacing;
    return spacing !== 'none' ? "calc(" + width + " + " + theme.spacing[spacing] + ")" : width;
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return theme.spacing[spacing];
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return theme.spacing[spacing];
}, function (_a) {
    var mobileDirection = _a.mobileDirection;
    return mobileDirection && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (max-width: 767px) {\n        flex-direction: ", ";\n      }\n    "], ["\n      @media (max-width: 767px) {\n        flex-direction: ", ";\n      }\n    "])), mobileDirection);
});
var Grid = function (_a) {
    var _b = _a.spacing, spacing = _b === void 0 ? 'small' : _b, _c = _a.direction, direction = _c === void 0 ? 'row' : _c, _d = _a.justifyContent, justifyContent = _d === void 0 ? 'space-between' : _d, _e = _a.alignItems, alignItems = _e === void 0 ? 'stretch' : _e, children = _a.children, _f = _a.width, width = _f === void 0 ? '100%' : _f, rest = __rest(_a, ["spacing", "direction", "justifyContent", "alignItems", "children", "width"]);
    return (react_1.default.createElement(GridWrapper, __assign({ alignItems: alignItems, justifyContent: justifyContent, direction: direction, spacing: spacing, width: width }, rest), children));
};
exports.default = Grid;
var templateObject_1, templateObject_2;
